var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 33,
    viewBox: "0 0 102 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Visa",
    d: "M50.5049 0.583893L43.6891 32.501H35.4474L42.2642 0.583893H50.5049ZM85.1808 21.1929L89.52 9.20691L92.0168 21.1929H85.1808ZM94.3765 32.501H102L95.3476 0.583893H88.3109C86.7297 0.583893 85.3956 1.50519 84.8017 2.92552L72.4366 32.501H81.0918L82.8101 27.7349H93.3842L94.3765 32.501ZM72.8662 22.0798C72.9015 13.6558 61.2373 13.1921 61.318 9.42915C61.3422 8.28258 62.4323 7.06631 64.8131 6.75416C65.996 6.5996 69.2481 6.4814 72.9408 8.18358L74.3869 1.41528C72.4034 0.694004 69.8511 0 66.6766 0C58.5308 0 52.797 4.33878 52.7486 10.5515C52.6971 15.1458 56.8417 17.7097 59.9647 19.2371C63.1755 20.8019 64.2545 21.804 64.2403 23.2031C64.2192 25.3458 61.679 26.2893 59.3092 26.3267C55.1647 26.3923 52.7597 25.2064 50.8427 24.3113L49.3492 31.3049C51.2743 32.1908 54.8289 32.9606 58.5166 33C67.1738 33 72.838 28.7148 72.8662 22.0798ZM38.7277 0.583893L25.3745 32.501H16.6608L10.0901 7.02893C9.69076 5.4601 9.34386 4.88631 8.13076 4.22463C6.15126 3.14878 2.87899 2.13757 0 1.51125L0.196638 0.583893H14.2205C16.0074 0.583893 17.6158 1.77592 18.0212 3.83773L21.4921 22.3081L30.0686 0.583893H38.7277Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c45beac09f64edb4e58095d5c5a181c9.svg";
export { ForwardRef as ReactComponent };